<template>
  <div>
    <div v-if="loading" class="loading-mask">
      Loading...
    </div>

    <PageHeader :title="isSmallDevice?'':'タスクカレンダー'">
      <template #title-header-content>
        <div class="flex flex-1 w-full items-end flex-wrap">

          <div class="font-bold text-sm ml-auto mx-2 text-white">
            <div class="flex">
              <div @click="all(true)" class="font-bold text-blue-50 cursor-pointer px-3">全選択</div>
              <div @click="all(false)" class="font-bold text-blue-50 cursor-pointer px-3">全解除</div>
            </div>

            <div class="flex rounded text-center border border-blue-500 ml-3 bg-white">
              <div class="m-2">
                <input type="checkbox" id="main" v-model="filter.main" @change="getData()" :class="filter.main?'bg-blue-700':''">
                <label for="main" class="p-1 text-blue-700 font-bold whitespace-nowrap cursor-pointer">メイン</label>
              </div>
              <div class="m-2">
                <input type="checkbox" id="order" v-model="filter.order" @change="getData()" :class="filter.order?'bg-green-700':''">
                <label for="order" class="p-1 text-green-700 font-bold whitespace-nowrap cursor-pointer">受注</label>
              </div>
              <div class="m-2">
                <input type="checkbox" id="empDC" v-model="filter.empDC" @change="getData()" :class="filter.empDC?'bg-yellow-700':''">
                <label for="empDC" class="p-1 text-yellow-700 font-bold whitespace-nowrap cursor-pointer">DC雇入</label>
              </div>
              <div class="m-2" v-if="admin||manager||isGroup4">
                <input type="checkbox" id="empReg" v-model="filter.empReg" @change="getData()" :class="filter.empReg?'bg-pink-700':''">
                <label for="empReg" class="p-1 text-pink-700 font-bold whitespace-nowrap cursor-pointer">社員雇入</label>
              </div>
              <div class="border-r border-dotted border-gray-600"></div>
              <div class="m-2">
                <input type="checkbox" id="sub" v-model="filter.sub" @change="getData()" :class="filter.sub?'bg-gray-600':''">
                <label for="sub" class="p-1 text-gray-600 font-bold whitespace-nowrap cursor-pointer">サブ</label>
              </div>
            </div>
          </div>

          <div class="bg-white flex text-white font-bold text-sm p-2 rounded mx-2">
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==1?'bg-blue-700':'bg-gray-400'" @click="clickTitle(1)">担当分</div>
            <div class="w-28 rounded py-1 text-center cursor-pointer mr-2" :class="filter.title==2?'bg-blue-700':'bg-gray-400'" @click="clickTitle(2)">部署検索</div>
          </div>

          <PrimaryButton text="検索" @click="getData()" class="min-w-100px block ml-4" :buttonContents="'要'" :disabled="loading" />
          <PrimaryButton text="クリア" v-if="!isSmallDevice" class="off px-1 block ml-4 whitespace-nowrap" @click="clear" :buttonContents="'要'" />
        </div>
      </template>
      <template #page-header-content>
        <div class="flex-1 flex justify-between items-end mt-1">
          <div class="text-xs font-bold text-white self-center flex-1">
            <p>※タスクをクリックで画面遷移</p>
            <p v-if="filter.title==2">※期間内の該当者のみ表示</p>
          </div>

          <div v-if="filter.title==1" class="flex-1">
            <!-- 月切り替え -->
            <div class="flex items-center text-white justify-center">
              <!-- 前月 -->
              <PrimaryButton @click="prevMonth()" class="block mr-3 bg-blue-100 border-blue-700 rounded-2xl py-1" :buttonContents="'要'" :disabled="loading" ><Icon slot="before" iconName="ChevronLeft" class="h-8 w-8 text-blue-700" /></PrimaryButton>
              <!-- 現在の表示年月 -->
              <div class="font-bold">{{ monthYear() }}</div>
              <!-- 翌月 -->
              <PrimaryButton @click="nextMonth()" class="block ml-3 bg-blue-100 border-blue-700 rounded-2xl py-1" :buttonContents="'要'" :disabled="loading" ><Icon slot="before" iconName="ChevronRight" class="h-8 w-8 text-blue-700" /></PrimaryButton>
            </div>
          </div>
          <div v-else-if="filter.title==2" class="w-fit flex-1">
            <div class="flex items-end justify-center">
              <PrimaryButton @click="prevWeek()" class="block mr-3 bg-blue-100 border-blue-700 py-0.5 self-end rounded-2xl" :buttonContents="'要'" :disabled="loading" ><Icon slot="before" iconName="ChevronLeft" class="h-8 w-8 text-blue-700" /></PrimaryButton>

              <WmsDateInput
                v-model="filter.start"
                class="w-100px"
              />
              <div class="text-lg text-white mx-1 font-bold self-center">～</div>
              <WmsDateInput
                v-model="filter.end"
                class="w-100px"
              />

              <PrimaryButton @click="nextWeek()" class="block ml-3 bg-blue-100 border-blue-700 rounded-2xl py-0.5 self-end" :buttonContents="'要'" :disabled="loading" ><Icon slot="before" iconName="ChevronRight" class="h-8 w-8 text-blue-700" /></PrimaryButton>

              <!-- 部署 -->
              <select
                v-model="filter.department"
                class="border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 font-bold ml-3 mt-1 py-1.5 text-sm"
                @change="changeDep()"
              >
                <option
                  v-for="row in depList" :key="row.departmentId"
                  :value="row.name">
                  {{ row.name }}
                </option>
              </select>
            </div>
            <!-- デンタツ -->
            <!-- <div class="text-xs font-bold text-white ml-auto w-fit">（{{ filter.dentatsu }}も対象）</div> -->
          </div>

          <div class="flex-1 text-right">
            <ListDropdownButton @select="toList" class="w-32" />
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-36 w-screen bottom-4 -mt-2">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 h-full ---overflow-auto">

          <div class="w-full h-full overflow-auto rounded-md" ref="scrollArea">
            <!-- 担当分 -->
            <div v-if="filter.title === 1">
              <div>
                <!-- 曜日ヘッダー -->
                <div class="grid grid-cols-7 mb-1 sticky top-0 z-10 bg-white bg-opacity-50">
                  <div
                    v-for="(w, i) in weeks"
                    :key="i"
                    class="text-center text-xs font-bold py-1"
                    :class="{
                      'text-red-700': i === 0,   // 日曜
                      'text-blue-700': i === 6   // 土曜
                    }"
                  >
                    {{ w }}
                  </div>
                </div>

                <!-- カレンダー本体 -->
                <div class="grid grid-cols-7  border-t border-gray-200">
                  <div
                    v-for="(day, idx) in days"
                    :key="'d'+idx"
                    class=" min-h-[110px] p-1 flex flex-col"
                    :class="[!day? 'bg-white border-0':'border border-gray-400 bg-gray-200' , day && today==day.date?'bg-yellow-100':'']"
                  >
                    <!-- 日付 -->
                    <div
                      v-if="day"
                      class="text-xs font-bold ml-auto"
                      :class="{
                        'text-red-700': isSunday(day.date),
                        'text-blue-700': isSaturday(day.date),
                        'text-gray-700': !isSunday(day.date) && !isSaturday(day.date)
                      }"
                    >
                      <!-- 日にちの部分のみ -->
                      {{ Number(day.date.slice(8, 10)) }}
                    </div>

                    <!-- タスク -->
                    <div v-if="day" class="mt-1 flex-1">
                      <div
                        v-for="(m, i) in tasksByDate[day.date] || []"
                        :key="'m'+i"
                        class="text-xs px-1 py-[2px] rounded font-bold my-1 truncate border"
                        :class="m.class"
                      >
                        <div class="min-w-0">
                          <div class="truncate cursor-pointer" @click="openPage(m, true)">
                            {{ m.main }}
                          </div>
                          <div
                            v-for="(s, j) in m.subs || []"
                            :key="i+'s'+j"
                            class="px-1 py-[2px] rounded m-1 text-white truncate cursor-pointer"
                            :class="m.subClass"
                            @click="openPage(m, false)"
                          >
                            {{ s }}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 部署検索 -->
            <div v-else-if="filter.title === 2">
              <table v-if="!loading && tasks && tasks.length" class="w-full">
                <thead class="sticky top-0 bg-colu text-xs text-gray-700 z-5 bg-white bg-opacity-80">
                  <tr>
                    <th v-for="(c, i) in columns" :key="'col'+i" class="p-2 whitespace-nowrap border-r border-gray-400" :class="i==0?'sticky left-0 z-20 bg-white':''">
                      {{ c.val }}
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-gray-200">
                  <tr v-for="(staff, i) in Object.keys(tasksByDate) || []" :key="'l'+i" class="">

                    <td v-for="(col, j) in columns" :key="i+'l'+j" class="p-2 border-r border-b border-gray-400" :class="j?['align-top', todayColor(col.key)]:'sticky left-0 bg-white'">
                      <!-- スタッフ -->
                      <div v-if="j==0" class="font-bold text-gray-700 whitespace-nowrap w-fit text-sm">{{ staff }}</div>

                      <!-- 日にちごと -->
                      <div v-else-if="tasksByDate[staff][col.key]" class="text-xs font-bold">
                        <div
                          v-for="(m, k) in tasksByDate[staff][col.key]" :key="i+'l'+j+'l'+k"
                          class="text-xs px-1 py-[2px] rounded font-bold my-1 truncate border min-w-0 max-w-md"
                          :class="m.class"
                        >

                          <div class="min-w-0">
                            <div class="truncate cursor-pointer" @click="openPage(m, true)">
                              {{ m.main }}
                            </div>
                            <div
                              v-for="(s, j) in m.subs || []"
                              :key="i+'s'+j"
                              class="px-1 py-[2px] rounded m-1 text-white truncate cursor-pointer"
                              :class="m.subClass"
                              @click="openPage(m, false)"
                            >
                              {{ s }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>



            <div v-if="filter.title === 2 && !loading && (!tasks || !tasks.length)" class="w-full h-full text-gray-400 flex justify-center">
              <EmptyMessage
                iconName="Document"
                message="該当する案件はありません。"
                class="w-fit m-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import EmptyMessage from '@components/EmptyMessage.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import ListDropdownButton from '../components/ListDropdownButton.vue'
import * as requestPostManager from '@managers/requestPostManager'
import * as moment from 'moment'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'

import PageModel from '../../main/pages/PageModel.vue'

const SETTION_STRAGE_NAME = 'taskCalendar'

const COLUMNS_ROW = [{ key: 'staff', val: '担当者名' }]

const ITEM = ['main', 'order', 'empDC', 'empReg', 'sub']

export default {
  extends: PageModel,
  components: {
    Icon,
    PrimaryButton,
    PageHeader,
    EmptyMessage,
    WmsDateInput,
    ListDropdownButton
  },

  data() {
    return {
      loading: false,
      reload: 0,
      // 検索
      filter: {
        main: true,
        sub: true,
        order: true,
        orderSub: true,
        empDC: true,
        empReg: true,
        title: 1,
        start: moment().format('YYYY-MM-DD'),
        end: moment().add(6, 'days').format('YYYY-MM-DD'),
        month: moment().format('YYYY-MM-01'),
        department: '',
        dentatsu: ''
      },
      // 「部署検索」のカラム
      columns: utils.clone(COLUMNS_ROW),
      // 部署リスト
      depList: utils.clone(this.$store.getters.departmentList),
      // 曜日
      weeks: ['日', '月', '火', '水', '木', '金', '土'],
      // 本日
      today: moment().format('YYYY-MM-DD'),
      // リスト
      tasks: [],
    }
  },

  // watch: {
  // },

  computed: {
    /**
     * ログインユーザー名カナ削除
     */
    userName() {
      return utils.deleteKana(this.$store.getters.user.user_name)
    },

    /**
     * ログインユーザーID
     */
    userId() {
      return this.$store.getters.user.id
    },

    /**
     * メインの所属部署名
     */
    mainDepartment() {
      const res = this.$store.getters.loginUserData
      return res.departmentName
    },

    /**
     * 所属部署（兼任含む）
     */
    dualPosition() {
      return this.$store.getters.dualPosition
    },

    /**
     * 所属部署名のみの配列
     */
    dualPositionNames() {
      if (this.dualPosition && this.dualPosition.length) {
        const res = this.dualPosition.map(row => row.departmentName)
        if (res && res.length) {
          return res
        }
      }
      return []
    },

    /**
     * 所属部署IDのみの配列
     */
    dualPositionIds() {
      if (this.dualPosition && this.dualPosition.length) {
        const res = this.dualPosition.map(row => row.departmentId)
        if (res && res.length) {
          return res
        }
      }
      return []
    },

    /**
     * 権限
     */
    auth() {
      return this.$store.getters.auth
    },

    /**
     * 管理者権限あり
     */
    admin() {
      return utils.admin(this.auth)
    },

    /**
     * 社員面接権限あり
     */
    regularStaffAuth() {
      if (this.auth.regularStaffAuth) {
        return true
      }
      return false
    },

    /**
     * G4以上か
     */
    isGroup4() {
      return utils.isGroup4(this.$store.getters.user.group_num)
    },

    /**
     * 人事総務経理所属か否か
     */
    manager() {
      return utils.manager(this.dualPosition)
    },

    /**
     * スマホorタブレット
     */
    isSmallDevice() {
      return (utils.deviceInfo.isMobile || utils.deviceInfo.isTablet)
    },

    /**
     * データを期限日をキーにしてオブジェクトに成型
     */
    tasksByDate() {
      const map = {}

      this.tasks.forEach(t => {
        // 色をセット
        if (t.type === 'apollo_request_post') {
          // メインタスク
          t.class = 'border-blue-700 bg-blue-700 text-white'
          t.subClass = 'bg-light-blue-600'
          if (t.subs && t.subs.length) {
            // サブタスク
            t.class = 'border-blue-700 text-gray-700 bg-white'
          }

          // 雇い入れ
          if (t.category.includes('雇い入れ（清掃員）') || t.category.includes('雇い入れ（社員）') || t.category.includes('雇い入れ')) {
            // 清掃員
            if (!t.employmentRegularStaff) {
              // メインタスク
              t.class = 'border-yellow-700 bg-yellow-700 text-white'
              t.subClass = 'bg-yellow-600'
              if (t.subs && t.subs.length) {
                // サブタスク
                t.class = 'border-yellow-700 text-gray-700 bg-white'
              }
            // 社員
            } else {
              // メインタスク
              t.class = 'border-pink-700 bg-pink-700 text-white'
              t.subClass = 'bg-pink-500'
              if (t.subs && t.subs.length) {
                // サブタスク
                t.class = 'border-pink-700 text-gray-700 bg-white'
              }
            }
          }
        } else {
          // 受注タスク
          t.class = 'border-green-700 bg-green-700 text-white'
          t.subClass = 'bg-teal-600'
          if (t.subs && t.subs.length) {
            // サブタスク
            t.class = 'border-green-700 text-gray-700 bg-white'
          }
        }

        // 担当分
        if (this.filter.title === 1) {
          if (!map[t.date]) {
            map[t.date] = []
          }
          map[t.date].push(t)

        // 部署
        } else {
          const staff = utils.deleteKana(t.staff)
          if (!map[staff]) {
            map[staff] = {}
          }
          if (!map[staff][t.date]) {
            map[staff][t.date] = []
          }
          map[staff][t.date].push(t)
        }
      })

      // 部署検索
      if (this.filter.title === 2) {
        let mitei = {}
        let main = {}
        let other = {}
        for (let i = 0; i < Object.keys(map).length; i++) {
          const key = Object.keys(map)[i]
          switch (key) {
            case '未定':
              mitei[key] = map[key]
              break;
            case this.userName:
              main[key] = map[key]
              break;

            default:
              other[key] = map[key]
              break;
          }
        }
        this.getScrollArea()
        return { ...mitei, ...main, ...other }
      }
      this.getScrollArea()
      return map
    },

    /**
     * カレンダー日付生成
     */
    days() {
      return this.createCalendarDays()
    },

    /**
     * 所属部署
     */
    departmentName() {
      const user = this.$store.getters.loginUserData
      if (user && user.departmentName) {
        return user.departmentName
      }
      return ''
    },
  },

  created() {
    // メイン一覧、進捗一覧の一覧データ保持をリセット
    sessionStorage.removeItem('requestPostListLast')
    sessionStorage.removeItem('subListLast')

    this.getCondition()
    this.getData()
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      if (this.loading) {
        return
      }

      const allFalse = ITEM.every(v => !this.filter[v])
      if (allFalse) {
        this.tasks = []
        return
      }

      this.loading = true
      // 担当分
      if (this.filter.title == 1) {
        this.tasks = await requestPostManager.getTaskCalendar(
          this,
          this.filter,
          this.userName,
          this.userId,
          this.isGroup4,
          this.admin,
          this.regularStaffAuth,
          this.manager,
          this.mainDepartment,
          this.dualPositionNames,
          this.dualPositionIds
        )
      // 部署検索
      } else if (this.filter.title == 2) {
        // 開始日、終了日
        if (!this.filter.start || !this.filter.end) {
          await dialogs.showErrorDialog('検索期間', '検索期間を入力してください。')
          this.loading = false
          return
        }
        if (this.filter.start > this.filter.end) {
          await dialogs.showErrorDialog('検索期間 不正', '検索期間が逆になっています。')
          this.loading = false
          return
        }

        // カラム生成
        this.columns = utils.clone(COLUMNS_ROW)
        let current = new Date(this.filter.start)
        const end = new Date(this.filter.end)

        const weekDays = ['日', '月', '火', '水', '木', '金', '土']

        while (current <= end) {
          const y = current.getFullYear()
          const m = String(current.getMonth() + 1).padStart(2, '0')
          const d = String(current.getDate()).padStart(2, '0')
          const w = weekDays[current.getDay()]

          const date = `${y}-${m}-${d}`
          const val = `${y}/${m}/${d}（${w}）`
          this.columns.push({ key: date , val, date })

          // 翌日へ
          current.setDate(current.getDate() + 1)
        }

        this.tasks = await requestPostManager.getTaskCalendar(
          this,
          this.filter,
          this.userName,
          this.userId,
          this.isGroup4,
          this.admin,
          this.regularStaffAuth,
          this.manager,
          this.mainDepartment,
          this.dualPositionNames,
          this.dualPositionIds
        )
      }
      this.setSessionStorage()
      this.loading = false
    },

    /**
     * カレンダー日付生成
     */
    createCalendarDays() {
      const day = this.filter.month
      const start = moment(day).startOf('month')
      const end = moment(day).endOf('month')
      const days = []

      // ★ 月初の曜日（0:日〜6:土）
      const firstDayOfWeek = start.day()

      // ★ 空白を追加
      for (let i = 0; i < firstDayOfWeek; i++) {
        days.push(null)
      }

      const date = start.clone()

      while (date.isSameOrBefore(end)) {
        days.push({
          date: date.format('YYYY-MM-DD')
        })
        date.add(1, 'day')
      }

      return days
    },

    /**
     * 日曜日判定
     * @param date 日付
     */
    isSunday(date) {
      return moment(date).day() === 0
    },

    /**
     * 土曜日判定
     */
    isSaturday(date) {
      return moment(date).day() === 6
    },

    /**
     * 月移動（前）
     */
    prevMonth() {
      this.filter.month = moment(this.filter.month).subtract(1, 'month').format('YYYY-MM-01')
      this.getData()
    },

    /**
     * 月移動（後）
     */
    nextMonth() {
      this.filter.month = moment(this.filter.month).add(1, 'month').format('YYYY-MM-01')
      this.getData()
    },

    /**
     * 週移動（前）
     */
    prevWeek() {
      // 現在のstartマイナス1日が終了日
      this.filter.end = moment(this.filter.start).add(-1, 'days').format('YYYY-MM-DD')
      // 終了マイナス6日が開始日
      this.filter.start = moment(this.filter.end).add(-6, 'days').format('YYYY-MM-DD')
      this.getData()
    },

    /**
     * 週移動（後）
     */
    nextWeek() {
      // 終了プラス1日が開始日
      this.filter.start = moment(this.filter.end).add(1, 'days').format('YYYY-MM-DD')
      // 現在のstartプラス6日が終了日
      this.filter.end = moment(this.filter.start).add(6, 'days').format('YYYY-MM-DD')
      this.getData()
    },

    /**
     * 表示切替
     * @param val 表示内容
     */
    clickTitle(val) {
      this.filter.title = val
      if (val == 1) {
        this.createCalendarDays()
      } else if (val == 2) {
        // 部署
        if (!this.filter.department) {
          this.filter.department = this.departmentName
          this.changeDep()
        }
      }
      this.getData()
    },

    /**
     * 詳細画面に遷移（メインタスクORサブタスク）
     */
    openPage(row, main) {
      this.saveScroll()
      if (main) {
        // メインタスク
        if (row.type == 'apollo_request_post') {
          this.$router.push({ name: 'RequestPost', query: { mode: 1, requestPostId: row._id }})
        // 受注メインタスク
        } else if (row.type == 'order') {
          this.$router.push({ name: 'RequestPost', query: { mode: 6, orderId: row._id }})
        }
      } else {
        // サブタスク
        if (row.type == 'apollo_request_post') {
          this.$router.push({ name: 'TaskRequest', query: { requestPostId: row._id }})
        // 受注サブタスク
        } else if (row.type == 'order') {
          this.$router.push({ name: 'TaskRequest', query: { mode: 1, orderId: row._id }})
        }
      }
    },

    /**
     * スクロール位置保存
     */
    saveScroll() {
      const el = this.$refs.scrollArea
      sessionStorage.setItem(SETTION_STRAGE_NAME + 'scrollTop', el.scrollTop)
    },

    /**
     * 検索条件をセッションストレージへ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify(this.filter)
      sessionStorage.setItem(SETTION_STRAGE_NAME, searchStr)
    },

    /**
     *  条件取得
     */
    getCondition() {
      const searchJson = sessionStorage.getItem(SETTION_STRAGE_NAME)
      const getItem = JSON.parse(searchJson)

      if (getItem) {
        this.filter = getItem
      }
      this.reload++
    },

    /**
     * 画面遷移前のスクロール位置と同じところへ
     */
    async getScrollArea() {
      await utils.wait(1000)
      const el = this.$refs.scrollArea
      const pos = sessionStorage.getItem(SETTION_STRAGE_NAME + 'scrollTop')
      if (pos) el.scrollTo({
        top: Number(pos),
        behavior: 'smooth'
      })
      sessionStorage.removeItem(SETTION_STRAGE_NAME + 'scrollTop')
    },

    /**
     * カレンダの年月表示
     */
    monthYear() {
      return this.filter.month.slice(0, -2).replace('-', '年').replace('-', '月')
    },

    /**
     * 全選択・全解除
     * @param val true・false
     */
    all(val) {
      if (val) {
        ITEM.forEach((i) => {
          this.filter[i] = true
        })
      } else {
        ITEM.forEach((i) => {
          this.filter[i] = false
        })
      }
      this.getData()
    },

    /**
     * 今日のセルカラー
     * @param day
     */
    todayColor(day) {
      if (this.today == day) {
        return 'bg-yellow-100'
      }
    },

    /**
     * 部署変更
     */
    changeDep() {
      // 部署IDを取得
      const dep = this.depList.find((d) => {
        return d.name === this.filter.department
      })

      if (dep) {
        const den = this.$store.getters.transDepartmentList.find((t) => {
          return t.transDepartment === dep.departmentId
        })
        if (den && den.name) {
          this.filter.dentatsu = den.name
        }
      }
      this.reload++
    },

    /**
     * 検索条件をクリア
     */
    clear() {
      sessionStorage.removeItem(SETTION_STRAGE_NAME)
      sessionStorage.removeItem(SETTION_STRAGE_NAME + 'scrollTop')
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },

    /**
     * 一覧へ
     * @param val
     */
    toList(val) {
      if (val == 'main') {
        // メインタスク一覧に遷移
        this.$router.push({ name: 'RequestPostList' })
      } else if (val == 'sub') {
        // 進捗一覧に遷移
        this.$router.push({ name: 'RequestPostProgressList' })
      }
    }
  }
}
</script>

<style scoped>

/* .table-h {
  max-height: calc(100vh - 80px);
} */

/* table {
  width: 100%;
  border-collapse: collapse;
}

.bg-colu {
  background: #ebf0fb;
} */

/* .hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
} */

.z-5 {
  z-index: 5;
}

</style>